import { render } from "./courseIntroduce.vue?vue&type=template&id=822f6f7a&scoped=true&ts=true"
import script from "./courseIntroduce.vue?vue&type=script&lang=ts"
export * from "./courseIntroduce.vue?vue&type=script&lang=ts"

import "./courseIntroduce.vue?vue&type=style&index=0&id=822f6f7a&lang=scss&scoped=true"

import exportComponent from "/apps/srv/jenkins/workspace/feihua_fe_mqimengweb_online/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822f6f7a"]])

export default __exports__